<template>
  <v-card v-if="video">
    <v-img
      v-if="videoCover"
      class="white--text align-end"
      height="200px"
      :src="videoCover"
    />

    <v-card-text class="text--primary">
      <div class="title">{{ video.title }}</div>
      <div>{{ video.description }}</div>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="remove" color="red" text>
        Remove
      </v-btn>

      <v-btn @click="edit" color="primary" text>
        Edit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ResourceVideo from '@/models/ResourceVideo'
export default {
  props: {
    video: {
      type: ResourceVideo
    }
  },
  data() {
    return {
      cover: null
    }
  },
  computed: {
    videoCover() {
      if (this.cover) {
        return this.cover
      } else if (this.video.cover) {
        return this.video.cover.url
      }
      return null
    }
  },
  mounted() {
    this.imageChanged(this.video.cover)
  },
  methods: {
    imageChanged(image) {
      if (image && image instanceof Blob) {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
          this.cover = reader.result
        }
      }
    },
    remove() {
      this.$emit('remove', this.video)
    },
    edit() {
      this.$emit('edit', this.video)
    }
  },
  watch: {
    video(video) {
      this.imageChanged(video.cover)
    }
  }
}
</script>
